import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  TextField,
  Fade,
} from "@mui/material";
import SearchableDropDown from "@Components/DropDown/SearchableDropDown";
import LoadingComponent from "@Components/LoadingComponent/LoadingComponent";
import { useDispatch } from "react-redux";
import { setSnackbar } from "@Redux/snackBarSlice";
import { GET_DELEGATION_USERS,REQUEST_DELEGATION } from "@API/APIRoutes";
import useGetAll from "../../Hooks/useGetAll";
import usePostItem from "../../Hooks/usePostItem";

const DelegationRequestPopup = ({ open, onClose,requestId,categoryAssignmentId }) => {
  const [members, setMembers] = useState([]);
  const { loading: loadingMembers, getAll } = useGetAll();
  const { loading: sending, postItem } = usePostItem();
  const [selectedMember, setSelectedMember] = useState("");
  const [reason, setReason] = useState("");
  const [isEmpty, setIsEmpty] = useState(false);
  const [reasonError, setReasonError] = useState(false);
  const dispatch = useDispatch();

  const handleClose = () => {
    setSelectedMember("");
    setReason("");
    setIsEmpty(false);
    setReasonError(false);
    onClose();
  };

  useEffect(() => {
    getAll(`${GET_DELEGATION_USERS}/${categoryAssignmentId}`, "Failed to fetch members").then((data) => {
      console.log("Fetched members:", data);
      setMembers(
        data.map((member) => ({
          id: member.id,
          name: member.username,
          email: member.email,
        }))
      );
    });
  }, []);

  const handleSend =async () => {
    if (!selectedMember) {
      setIsEmpty(true);
      return;
    }
    if (!reason.trim()) {
      setReasonError(true);
      return;
    }
    console.log("Selected member:", selectedMember);
    console.log("req id:", requestId);
    const delegationRequest= {
      exitRequestId: requestId,
      proposedDelegateId: selectedMember,
      requestReason: reason.trim(),
      categoryAssignmentId:categoryAssignmentId,
    };
    console.log("Sending delegation request:", delegationRequest);
   await postItem(
      REQUEST_DELEGATION,
      delegationRequest,
      handleClose,
      "Delegation request sent successfully!",
      "Failed to send delegation request!",
      true
    );
  };

  const handleCancel = () => {
    setSelectedMember("");
    setReason("");
    setIsEmpty(false);
    setReasonError(false);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleCancel} maxWidth="md" fullWidth>
      <DialogTitle>Delegation Request</DialogTitle>
      <DialogContent>
        <Typography mb={2}>Select R&amp;D member to delegate to:</Typography>
        <SearchableDropDown
          state={selectedMember}
          setState={setSelectedMember}
          name="R&D Member"
          label=""
          items={members}
          placeholder="Select member..."
          size="small"
          loading={loadingMembers}
          isEmpty={isEmpty}
          setIsEmpty={setIsEmpty}
          dropDownError={isEmpty}
          disabled={loadingMembers || sending}
        />

        {/* Reason text field - shows with animation when member is selected */}
        <Fade in={!!selectedMember} timeout={300}>
          <Box sx={{ mt: 3 }}>
            <Typography mb={1}>Delegation Reason:</Typography>
            <TextField
              fullWidth
              multiline
              rows={3}
              value={reason}
              onChange={(e) => {
                setReason(e.target.value);
                if (reasonError) setReasonError(false);
              }}
              placeholder="Please provide a reason for this delegation request..."
              error={reasonError}
              helperText={
                reasonError ? "Please provide a reason for the delegation" : ""
              }
              disabled={sending}
              variant="outlined"
              size="small"
            />
          </Box>
        </Fade>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} disabled={sending}>
          Cancel
        </Button>
        <Box sx={{ position: "relative" }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSend}
            disabled={
              sending || loadingMembers || !selectedMember || !reason.trim()
            }
            sx={{ minWidth: 120 }}
          >
            {sending ? (
              <LoadingComponent
                size={22}
                thickness={4}
                color="inherit"
                style={{ marginRight: 8 }}
              />
            ) : null}
            {sending ? "" : "Send Request"}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default DelegationRequestPopup;
